import { Component } from '@angular/core';

@Component({
  selector: 'pp-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss'],
})
export class BillingHistoryComponent {}
